<template>
	<div class="app--engagement-auth">
		<div class="container">
			<div class="row align-items-center justify-content-center">
				<div class="col-12 col-md-10 col-lg-8 col-xl-6 col-xxl-5">
					<div class="app--auth">
						<div class="heading" v-if="theme.auth.image || theme.auth.info" :class="heading">
							<div v-if="theme.auth.image && info.logo" class="logo me-2">
								<img :src="info.logo" class="rounded">
							</div>
							<div class="info" v-if="theme.auth.info">
								<div class="title">{{ info.name }}</div>
								<div class="description">
									<div>{{ info.email }}</div>
									<div>{{ info.phone }}</div>
								</div>
							</div>
						</div>
						<div v-if="type != 'web-engagement'" class="content bg--auth border--auth" :class="classes">
							<form novalidate ref="authform" @submit.prevent="submit(section, $event)">
								<h5 v-if="msg.title" class="title">{{ msg.title }}</h5>

								<div v-if="!response" class="mb-1 small text-center text--color-default"
									 v-html="msg.message"/>
								<div v-if="!response && msg.method" class="small text-center text--color-default">
									{{ trans('buttons.the') }} {{ msg.method }}: <span
									class="font-monospace text--color-muted px-1">{{ masked }}</span>
								</div>

								<div v-if="response" class="mb-1 alert alert-dismissible p-2" :class="response.class">
									<strong>{{ response.title }}</strong>
									<p v-if="response.description">{{ response.description }}</p>
									<button v-if="response.close" type="button" class="btn-close"
											@click="response = null"/>
								</div>

								<auth-pin v-if="!error && section == 'verify'" v-model:section="section"
										  v-model:pin="fields.pin" @request:pin="requestpin()"/>
								<auth-pass v-if="!error && section == 'signin'" v-model:section="section"
										   v-model:password="fields.password"/>
								<auth-create v-if="!error && section == 'password'" v-model:section="section"
											 v-model:password="fields.password"
											 v-model:confirm="fields.password_confirm"/>

								<div v-if="!error" class="d-flex align-items-center justify-content-between">
									<app-button v-if="msg.submit" class="app--button border--button primary"
												type="submit"
												:loading="loading" :label="msg.submit"/>
									<app-button v-if="msg.cancel" class="app--button border--button muted"
												:disabled="loading" :label="msg.cancel" @click="cancel"/>
								</div>
							</form>
						</div>
						<div v-if="type == 'web-engagement'" class="content bg--auth border--auth" :class="classes">
							<auth-web-signin v-if="websection == 'websignin'" :pages="pages"></auth-web-signin>
							<auth-web-signup v-if="websection == 'websignup'" :pages="pages"></auth-web-signup>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '../store'
import Pin from './auth/Pin'
import Pass from './auth/Pass'
import Create from './auth/Create'
import WebSignin from './auth/web/Signin'
import WebSignup from './auth/web/Signup'

export default {
	props: {
		pages: {type: Array, required: true}
	},
	computed: {
		type() {
			return store.state.type
		},
		theme() {
			return store.state.theme
		},
		info() {
			return store.state.info.company
		},
		member() {
			return store.state.members.find(m => m.active == true)
		},
		loading() {
			return store.state.loading
		},
		heading() {
			return this.theme.logo && this.theme.info ? 'justify-content-start' : 'justify-content-center'
		},
		classes() {
			return ['color', 'font', 'size'].map(i => 'text--' + i + '-' + this.theme.auth[i])
		},
		method() {
			return store.state.auth.method == 'PASSWORD' && this.member.security == 'LOW' ? 'SMS' : store.state.auth.method
		},
		masked() {
			return this.method == 'EMAIL' ? this.member.email : this.member.phone.code + ' ' + this.member.phone.number
		},
		error() {
			return store.state.error
		},
		websection() {
			return store.state.auth.section
		},
		msg() {
			if (this.section == 'verify') {
				let message = this.trans('auth.pin_message') + ' ' + (
					this.method == 'SMS' ? this.trans('auth.phone_number') : this.trans('auth.email')
				)
				if (store.state.auth.method == 'PASSWORD' && (!this.member.phone || !this.member.phone.number)) {
					message = this.trans('auth.pin_advisor')
				}

				return {
					title: this.trans('auth.title'),
					message: message,
					method: '',
					submit: this.trans('buttons.verify'),
					cancel: this.trans('buttons.cancel'),
				}
			}
			if (this.section == 'signin') {
				return {
					title: this.trans('auth.title'),
					message: this.trans('auth.password_message'),
					method: '',
					submit: this.trans('buttons.signin'),
					cancel: this.trans('buttons.cancel'),
				}
			}
			if (this.section == 'forgot') {
				let message = this.trans('auth.password_forgot')
				let method = this.trans('auth.phone_number')
				let submit = this.trans('buttons.pin')

				if (!this.member.phone || !this.member.phone.number) {
					message = this.trans('auth.security_pin_required')
					method = ''
					submit = this.trans('buttons.pin_request')
				}

				return {
					title: this.trans('auth.title'),
					message: message,
					method: method,
					submit: submit,
					cancel: this.trans('buttons.cancel'),
				}
			}
			if (this.section == 'password') {
				return {
					title: this.trans('auth.title'),
					message: this.trans('auth.password_create'),
					method: null,
					submit: this.trans('buttons.create'),
					cancel: this.trans('buttons.cancel'),
				}
			}

			if (this.method == 'SMS' && (!this.member.phone.code || !this.member.phone.number)) {
				return {
					title: this.trans('auth.title'),
					message: this.trans('auth.phone_error'),
					method: null,
					submit: null,
					cancel: this.trans('buttons.cancel'),
				}
			}

			return {
				title: this.trans('auth.title'),
				message: this.trans('auth.signin_message'),
				method: this.method == 'SMS' ? this.trans('auth.phone_number') : this.trans('auth.email'),
				submit: this.trans('buttons.pin'),
				cancel: this.trans('buttons.cancel'),
			}
		}
	},
	watch: {
		section() {
			if (this.$refs.authform) {
				this.$validationReset(this.$refs.authform)
			}
			this.response = null
		}
	},
	data() {
		return {
			section: '',
			response: null,
			fields: {pin: '', password: '', password_confirm: ''}
		}
	},
	mounted() {
		if (store.state.auth.method == 'PASSWORD' && this.member.security == 'HIGH') {
			this.section = 'signin'
		} else if (store.state.auth.method == 'PASSWORD' && (!this.member.phone || !this.member.phone.number)) {
			this.section = 'verify'
		}
	},
	methods: {
		submit(section, event) {
			if (this.loading) return
			this.$validate(event).then(() => {
				if (section == '' || section == 'forgot') {
					this.authpin(event)
				}
				if (section == 'verify' || section == 'signin') {
					this.authsignin(event)
				}
				if (section == 'password') {
					this.authpassword(event)
				}
			})
		},
		cancel() {
			store.dispatch('auth/cancel')
			this.section = store.state.auth.method == 'PASSWORD' && this.member && this.member.security == 'HIGH' ? 'signin' : ''
			this.response = null
		},
		requestpin() {
			store.dispatch('auth/pin', {method: 'RETRY'}).then(response => {
				if (response !== true) {
					this.response = {
						title: this.trans(response.title),
						description: this.trans(response.description),
						class: response.class
					}
				} else {
					this.response = {
						title: this.trans('auth.pin_success'),
						class: 'alert-info'
					}
				}
			})
		},
		authpin(event) {
			let m = this.method == 'PASSWORD' && (this.member.phone.code == null || this.member.phone.code == null)
				? 'RETRY' : this.method
			store.dispatch('auth/pin', {method: m}).then(response => {
				if (response !== true) {
					this.response = {
						title: this.trans(response.title),
						description: this.trans(response.description),
						class: response.class
					}
				} else {
					this.section = 'verify'
				}
			})
		},
		authsignin(event) {
			let payload = this.section == 'verify' ? {pin: this.fields.pin} : {password: this.fields.password}
			store.dispatch('auth/signin', payload).then(response => {
				if (!response.id) {
					this.response = {
						title: this.trans(response.title),
						description: this.trans(response.description),
						class: response.class
					}
				} else if (this.section == 'verify' && store.state.auth.method == 'PASSWORD') {
					this.section = 'password'
				} else {
					store.dispatch('open').then(response => {
						store.commit('auth/SET_ACTIVE', null)
						store.commit('SET_PAGE', store.state.download === true ? this.pages[this.pages.length - 1] : this.pages[1])
					})
				}
			})
		},
		authpassword(event) {
			store.dispatch('auth/password', this.fields).then(response => {
				if (!response.id) {
					this.response = {
						title: this.trans(response.title),
						description: this.trans(response.description),
						class: response.class
					}
				} else {
					store.dispatch('open').then(response => {
						store.commit('auth/SET_ACTIVE', null)
						store.commit('SET_PAGE', store.state.download === true ? this.pages[this.pages.length - 1] : this.pages[1])
					})
				}
			})
		},
		trans(key) {
			let trans = store.getters.trans(key)
			return trans ? trans : this.$t('front.' + key)
		}
	},
	components: {
		'auth-pin': Pin,
		'auth-pass': Pass,
		'auth-create': Create,
		'auth-web-signin': WebSignin,
		'auth-web-signup': WebSignup,
	}
}
</script>
